import React, { useCallback } from "react"

import { SettingRow, Switch } from "@coval/ui"

import type { WebSocketFieldProps } from "./types"

export const PlaybackMarkerFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const isEnabled = Boolean(metadata.marks_enabled)

  const handleToggle = useCallback(
    (checked: boolean) => {
      onMetadataUpdate({ marks_enabled: checked })
    },
    [onMetadataUpdate],
  )

  return (
    <SettingRow
      label="Playback Markers"
      tooltip='When enabled, {"type": "mark", "mark": {"name": "..."}} messages from the agent are echoed back once all preceding audio has been processed.'
    >
      {(controlId) => (
        <Switch
          id={controlId}
          checked={isEnabled}
          onCheckedChange={handleToggle}
          disabled={disabled}
        />
      )}
    </SettingRow>
  )
}
